<template>
	<v-dialog
		v-model="dialog"
		max-width="700px"
		:fullscreen="$vuetify.breakpoint.xs ? true : false"
		:transition="$vuetify.breakpoint.xs ? 'scroll-y-reverse-transition' : ''"
	>
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				class="ml-2"
				:text="text"
				:color="text ? 'white' : 'secondary'"
				@click.stop="dialog = true"
				v-bind="attrs"
				v-on="on"
			>
				<v-icon class="mr-2">mdi-information-outline</v-icon>
				台帳情報
			</v-btn>
		</template>
		<v-card>
			<v-app-bar dense dark flat color="primary">
				<v-app-bar-title class="color-white">この台帳について</v-app-bar-title>
				<v-spacer />
				<v-btn
					v-if="authorized && !$vuetify.breakpoint.xs"
					text
					color="white"
					@click="$router.push({ name: 'ledger_edit', params: { id: ledger.id } })"
				>
					<v-icon class="mr-2">mdi-pencil</v-icon>
					編集する
				</v-btn>
				<v-btn class="ml-2" icon dark @click="dialog = false" color="white">
					<v-icon>mdi-close</v-icon>
				</v-btn>
			</v-app-bar>
			<div class="pa-2">
				<v-row no-gutters justify="end">
					<v-btn
						v-if="authorized && $vuetify.breakpoint.xs"
						color="secondary"
						@click="$router.push({ name: 'ledger_edit', params: { id: ledger.id } })"
					>
						<v-icon class="mr-2">mdi-pencil</v-icon>
						編集する
					</v-btn>
				</v-row>
				<h4 class="text-h6 font-weight-bold color-secondary mb-2">基本情報</h4>
				<table width="100%" class="show-dialog-table">
					<tbody>
						<tr>
							<th width="30%">台帳名</th>
							<td width="70%">{{ ledger.name }}</td>
						</tr>
						<tr>
							<th width="30%">部門</th>
							<td width="70%">{{ ledger.department ? ledger.department.name : "なし" }}</td>
						</tr>
						<tr>
							<th width="30%">参照データ</th>
							<td width="70%">{{ ledger.locale_model_name }}</td>
						</tr>
						<tr v-if="ledger.exclusive_flag">
							<th width="30%">自身専用の台帳か</th>
							<td width="70%">自身専用</td>
						</tr>
						<tr>
							<th width="30%">最終変更ユーザー</th>
							<td width="70%">{{ ledger.user.full_name }}</td>
						</tr>
					</tbody>
				</table>
				<h4 class="text-h6 font-weight-bold color-secondary mb-2 mt-4">列情報</h4>
				<table width="100%" class="show-dialog-table">
					<tbody class="border-top" v-for="(column, i) in ledger.ledger_columns" :key="i">
						<tr>
							<th width="30%">列番号</th>
							<td width="70%">{{ column.order_number + 1 }}</td>
						</tr>
						<tr>
							<th width="30%">表示名</th>
							<td width="70%">{{ column.name }}</td>
						</tr>
						<tr>
							<th width="30%">項目名</th>
							<td width="70%">{{ column.locale_name }}</td>
						</tr>
						<tr>
							<th width="30%">計算式</th>
							<td width="70%">{{ displayFormula(column) }}</td>
						</tr>
						<tr>
							<th width="30%">台帳上での編集</th>
							<td width="70%">{{ column.editable_flag ? "可能" : "不可能" }}</td>
						</tr>
					</tbody>
				</table>
				<template v-if="ledger.ledger_filters.length">
					<h4 class="text-h6 font-weight-bold color-secondary mb-2 mt-4">初期フィルター</h4>
					<table width="100%" class="show-dialog-table">
						<tbody class="border-top" v-for="(filter, i) in ledger.ledger_filters" :key="i">
							<tr>
								<th width="30%">フィルター条件</th>
								<td width="70%">{{ filterText(filter) }}</td>
							</tr>
						</tbody>
					</table>
				</template>
			</div>
			<v-card-actions>
				<v-row no-gutters justify="end">
					<v-btn color="grey darken-1" text @click="dialog = false"> 閉じる </v-btn>
				</v-row>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	props: {
		ledger: {
			type: Object,
			required: false,
			default: () => ({}),
		},
		authorized: {
			type: Boolean,
			required: false,
			default: false,
		},
		text: {
			type: Boolean,
			required: false,
			default: false,
		},
	},
	data() {
		return {
			dialog: false,
			formula: {
				addition: "＋",
				subtraction: "−",
				multiplication: "×",
				division: "÷",
			},
		}
	},
	methods: {},
	computed: {
		displayFormula() {
			return (column) => {
				if (column.prefix_formula && column.prefix_number) {
					return `${column.prefix_number} ${this.formula[column.prefix_formula]} 元のデータ`
				} else if (column.suffix_formula && column.suffix_number) {
					return `元のデータ ${this.formula[column.suffix_formula]} ${column.suffix_number}`
				} else {
					return "なし"
				}
			}
		},
		filterText() {
			return (filter) => {
				const booleanChoice = ["_present", "_blank", "_null", "_not_null", "_true", "_false"]
				if (booleanChoice.includes(filter.condition)) {
					return `${filter.locale_name}の${filter.condition_text}`
				} else {
					return `${filter.locale_name}が${this.value(filter)}${filter.condition_text}`
				}
			}
		},
		value() {
			return (filter) => {
				if (filter.options.length) {
					let option
						console.log(filter.value)
					if (isNaN(filter.value)) {
						option = filter.options.find((o) => o.id == filter.value)
						} else {
						option = filter.options[filter.value]
					}
					return option ? option.name : null
				} else {
					return filter.value
				}
			}
		},
	},
}
</script>

<style lang="scss" scoped>
table {
	.border-top {
		border-top: 4px white solid;
	}
}
</style>